export var GLOBAL_STYLE_NAME = ':root';